import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../../home/components/Footer'
import NavHome from '../../home/components/NavHome'

const HomeLayout = (props) => {
  return (
    <>
        <NavHome width = {props.width}/>
        <Outlet /> 
        <Footer />
    </>
  )
}

export default HomeLayout
